export default __webpack_public_path__ + "static/communities-2M-0e3f3fb6505cbf7608267370ac2b6f22.jpg";